module.exports = __webpack_public_path__ + "static/img/CV.cc7f45d4.png";